import { isNil } from 'ramda';
import { useCallback, useMemo } from 'react';
import { useColumnsVisibilityLocalStorageState } from '../localStorage/useLocalStorageKeys';
const createDefaultVisibilityState = (defaultHiddenColumns) => defaultHiddenColumns.reduce((acc, v) => ({
    ...acc,
    [v]: false,
}), {});
export const useColumnsVisibility = (tableKey, allColumns, defaultHiddenColumns = []) => {
    const [tableVisibility, setTableVisibility] = useColumnsVisibilityLocalStorageState(tableKey, createDefaultVisibilityState(defaultHiddenColumns));
    const setColumnVisibility = useCallback((column, value) => {
        const newVisibility = {
            ...tableVisibility,
            [column.fieldName]: value,
        };
        setTableVisibility(newVisibility);
    }, [setTableVisibility, tableVisibility]);
    const isColumnVisible = useCallback((column) => {
        const visibleRecord = tableVisibility[column.fieldName];
        return isNil(visibleRecord) || visibleRecord;
    }, [tableVisibility]);
    const toggleColumnVisibility = useCallback((column) => {
        const isVisibile = isColumnVisible(column);
        setColumnVisibility(column, !isVisibile);
    }, [isColumnVisible, setColumnVisibility]);
    const setAllColumnsVisible = useCallback(() => setTableVisibility({}), [setTableVisibility]);
    const setAllColumnsHidden = useCallback(() => {
        const allHidden = allColumns.reduce((acc, column) => ({ ...acc, [column.fieldName]: false }), {});
        setTableVisibility(allHidden);
    }, [allColumns, setTableVisibility]);
    return useMemo(() => ({
        isColumnVisible,
        setAllColumnsHidden,
        setAllColumnsVisible,
        setColumnVisibility,
        toggleColumnVisibility,
    }), [isColumnVisible, setAllColumnsHidden, setAllColumnsVisible, setColumnVisibility, toggleColumnVisibility]);
};
//# sourceMappingURL=useColumnsVisibility.js.map